export default __webpack_public_path__ + "static/media/siegerads.6d132e8b.png";